import script from "./BSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./BSidebar.vue?vue&type=style&index=0&id=2113357f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2113357f"]])

export default __exports__